import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Students from "@/pages/Students";
import Programmes from "@/pages/Programmes";
import Flagship from "@/pages/Flagship";
import Technical from "@/pages/Technical";
import BusinessCreator from "@/pages/BusinessCreator";
import Scholarship from "@/pages/Scholarship";
import Enterprises from "@/pages/Enterprises";
import CSR from "@/pages/CSR";
import Talent from "@/pages/Talent";
import MarketingCell from "@/pages/MarketingCell";
import Research from "@/pages/Research";
import Membership from "@/pages/Membership";
import Institutions from "@/pages/Institutions";
import Press from "@/pages/Press";
import Article from "@/pages/Article";
import Contact from "@/pages/Contact";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Legal from "@/pages/Legal";

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/leads" element={<AdminDashboard />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/students" element={<Students />} />
          <Route path="/programmes" element={<Programmes />} />
          <Route path="/programmes/flagship" element={<Flagship />} />
          <Route path="/programmes/technical" element={<Technical />} />
          <Route path="/programmes/business-creator" element={<BusinessCreator />} />
          <Route path="/scholarship" element={<Scholarship />} />
          <Route path="/enterprises" element={<Enterprises />} />
          <Route path="/enterprises/csr" element={<CSR />} />
          <Route path="/enterprises/talent" element={<Talent />} />
          <Route path="/enterprises/marketing-cell" element={<MarketingCell />} />
          <Route path="/enterprises/research" element={<Research />} />
          <Route path="/enterprises/membership" element={<Membership />} />
          <Route path="/institutions" element={<Institutions />} />
          <Route path="/press" element={<Press />} />
          <Route path="/press/:slug" element={<Article />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal/privacy" element={<Legal kind="privacy" />} />
          <Route path="/legal/terms" element={<Legal kind="terms" />} />
          <Route path="/legal/cookies" element={<Legal kind="cookies" />} />
          <Route path="/legal/ethics" element={<Legal kind="ethics" />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
